export const EMAIL_ERROR_MESSAGE = 'Enter a valid email address.';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

export function isValidEmail(value) {
    const email = String(value || '').trim();
    return !!email && EMAIL_RE.test(email);
}

export function isBlankOrValidEmail(value) {
    const email = String(value || '').trim();
    return !email || isValidEmail(email);
}
